export const CARACTERISTICA_FIELDS = [
  'raca1',
  'raca2',
  'raca3',
  'raca4',
  'raca4mais',
  'raca5',
  'raca6',
  'raca7',
  'raca8',
  'raca9',
  'raca10',
  'raca11',
  'raca12',
  'raca13',
  'raca14',
  'raca14mais',
  'meloidogyneincognita',
  'meloidogynejavanica',
  'pratylenchusbrachyurus',
  'crancrodahaste',
  'pustulabacteriana',
  'manchaolhodera',
  'manchaalvo',
  'ferrugemasiatica',
  'podridaoradiculardefitoftora',
  'mofobranco',
  'oidio',
]
